import React from 'react';
import styles from './TargetStatus.scss';
export var ETargetStatusOperator;

(function (ETargetStatusOperator) {
  ETargetStatusOperator["greaterThan"] = "greaterThan";
  ETargetStatusOperator["greaterThanOrEqualTo"] = "greaterThanOrEqualTo";
  ETargetStatusOperator["lessThan"] = "lessThan";
  ETargetStatusOperator["lessThanOrEqualTo"] = "lessThanOrEqualTo";
  ETargetStatusOperator["equalTo"] = "equalTo";
  ETargetStatusOperator["notEqualTo"] = "notEqualTo";
})(ETargetStatusOperator || (ETargetStatusOperator = {}));

export var formatOperator = function formatOperator(operator) {
  switch (operator) {
    case ETargetStatusOperator.greaterThan:
      return '>';

    case ETargetStatusOperator.greaterThanOrEqualTo:
      return '≥';

    case ETargetStatusOperator.lessThan:
      return '<';

    case ETargetStatusOperator.lessThanOrEqualTo:
      return '≤';

    case ETargetStatusOperator.equalTo:
      return '=';

    default:
      return '≠';
  }
};

var yVerticalAlignment = function yVerticalAlignment(verticalAlignment) {
  switch (verticalAlignment) {
    case 'top':
      return '-1.05em';

    case 'bottom':
      return '1.05em';

    default:
      return '0';
  }
};

var xHorizontalAlignment = function xHorizontalAlignment(textAnchor) {
  switch (textAnchor) {
    case 'end':
      return '-1';

    case 'start':
      return '1';

    default:
      return '0';
  }
};

export var TargetStatus = function TargetStatus(_ref) {
  var _ref$orientation = _ref.orientation,
      orientation = _ref$orientation === void 0 ? 'vertical' : _ref$orientation,
      _ref$textAnchor = _ref.textAnchor,
      textAnchor = _ref$textAnchor === void 0 ? 'start' : _ref$textAnchor,
      _ref$verticalAlignmen = _ref.verticalAlignment,
      verticalAlignment = _ref$verticalAlignmen === void 0 ? 'bottom' : _ref$verticalAlignmen,
      dataTest = _ref.dataTest,
      config = _ref.config,
      _ref$valueFormatter = _ref.valueFormatter,
      valueFormatter = _ref$valueFormatter === void 0 ? function (v) {
    return v.toString();
  } : _ref$valueFormatter,
      _ref$x = _ref.x,
      x = _ref$x === void 0 ? 0 : _ref$x,
      _ref$y = _ref.y,
      y = _ref$y === void 0 ? 0 : _ref$y;

  var adjustmentProps = function adjustmentProps(dy) {
    return orientation === 'vertical' ? {
      dy: "".concat(dy, "em"),
      x: '0',
      y: yVerticalAlignment(verticalAlignment)
    } : {
      dy: "".concat(dy, "em"),
      x: xHorizontalAlignment(textAnchor),
      y: '16'
    };
  };

  return React.createElement("g", {
    "data-test": dataTest,
    transform: "translate(".concat(x, ", ").concat(y, ")")
  }, React.createElement("text", Object.assign({
    className: styles.labelText,
    "data-test": dataTest ? "".concat(dataTest, "-label-text") : 'label-text',
    textAnchor: textAnchor
  }, adjustmentProps(-0.25)), config.message), React.createElement("text", Object.assign({
    className: styles.valueText,
    "data-test": dataTest ? "".concat(dataTest, "-value-text") : 'value-text',
    textAnchor: textAnchor
  }, adjustmentProps(1)), "".concat(formatOperator(config.operator), " ").concat(valueFormatter(config.value))));
};
TargetStatus.displayName = 'TargetStatus';